import Field from '../Field';

const cards = {
  visa: /^4[0-9]{12}(?:[0-9]{3})?$/,
  mastercard: /^5[1-5][0-9]{14}$|^2(?:2(?:2[1-9]|[3-9][0-9])|[3-6][0-9][0-9]|7(?:[01][0-9]|20))[0-9]{12}$/,
  amex: /^3[47][0-9]{13}$/,
  discover: /^65[4-9][0-9]{13}|64[4-9][0-9]{13}|6011[0-9]{12}|(622(?:12[6-9]|1[3-9][0-9]|[2-8][0-9][0-9]|9[01][0-9]|92[0-5])[0-9]{10})$/,
  diners_club: /^3(?:0[0-5]|[68][0-9])[0-9]{11}$/,
  jcb: /^(?:2131|1800|35[0-9]{3})[0-9]{11}$/,
};

class CreditCard extends Field {
  sanitize(force = false) {
    super.sanitize(force);

    this.value.forEach((val, index) => {
      if (Field.isEmpty(val)) {
        return;
      }

      const rawValue = String(val).replace(/\s/g, '');
      this.setValue(rawValue, index);
      this.setDisplayValue(
        [...rawValue]
          .map((d, i) => (i % 4 === 0 ? ' ' + d : d))
          .join('')
          .trim(),
        index
      );
    });

    return this;
  }

  validate() {
    this.sanitize(true);
    super.validate();

    this.value.forEach((val, index) => {
      if (!this.needsValidation(index)) {
        return;
      }

      let good = false;
      Object.keys(cards).forEach(key => {
        if (cards[key].test(val.replace(/\s/g, ''))) {
          good = true;
        }
      });

      if (!good) {
        this.invalidate('Invalid credit card.', index);
      }
    });

    return this.isValid();
  }
}

export default CreditCard;
